import { render, staticRenderFns } from "./carouselPromociones.vue?vue&type=template&id=f487efea&scoped=true"
import script from "./carouselPromociones.vue?vue&type=script&lang=js"
export * from "./carouselPromociones.vue?vue&type=script&lang=js"
import style0 from "./carouselPromociones.vue?vue&type=style&index=0&id=f487efea&prod&scoped=true&lang=css"
import style1 from "./carouselPromociones.vue?vue&type=style&index=1&id=f487efea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f487efea",
  null
  
)

export default component.exports